import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_URL } from '../utils/constants';
import { ListResource } from '../utils/lazy-data-source';

import {
  ApiListWrapper,
  ApiRequestParams,
} from '../utils/types';

export enum UserRole {
  SYSTEM = 'rtls_admin',
  ENGINEER = 'rtls_engineer',
}

export interface User {
  login: string;
  role: UserRole;
  deleted: boolean;
  descr?: string;
  password?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UsersResource implements ListResource<User> {
  constructor(private httpClient: HttpClient) {
  }

  getList(params?: ApiRequestParams): Observable<ApiListWrapper<User>> {
    return this.httpClient.get<ApiListWrapper<User>>(`${BASE_URL}/data/users`, { params });
  }

  getItem(login: string): Observable<User> {
    return this.httpClient.get<User>(`${BASE_URL}/data/users/${login}`);
  }

  create(user: Partial<User>): Observable<void> {
    return this.httpClient.post<void>(`${BASE_URL}/data/users`, user);
  }

  update(login: string, user: Partial<User>): Observable<void> {
    return this.httpClient.put<void>(`${BASE_URL}/data/users/${login}`, user);
  }

  changeCurrentUserPassword(login: string, oldPassword: string, newPassword: string): Observable<void> {
    return this.httpClient.put<void>(`${BASE_URL}/data/users/pass/${login}`, {
      password_confirm: oldPassword,
      password: newPassword,
    });
  }

  changePassword(login: string, password: string): Observable<any> {
    return this.httpClient.put<void>(`${BASE_URL}/data/users/pass/${login}`, { password });
  }
}
